import React from 'react';
import PropTypes from 'prop-types';
import {isEmpty} from 'lodash';
import {Attachment} from './Attachment/Attachment';

export class Attachments extends React.Component {
    static propTypes = {
        attachments: PropTypes.arrayOf(
            PropTypes.shape({
                error: PropTypes.bool,
                file: PropTypes.shape(),
                name: PropTypes.string,
            })
        ),
        onRemove: PropTypes.func,
    };

    static defaultProps = {
        onRemove: () => {},
    };

    onRemove = (id) => {
        this.props.onRemove(id);
    };

    render() {
        const {attachments} = this.props;
        let attachmentList = [];

        if (isEmpty(attachments)) {
            return null;
        }

        attachments.forEach((attachment, index) => {
            attachmentList.push(
                <Attachment
                    error={attachment.error}
                    file={attachment.file}
                    id={index}
                    key={index}
                    name={attachment.name}
                    onRemove={this.onRemove}
                />
            );
        });

        return <div className="Attachments">{attachmentList}</div>;
    }
}
